import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Dayjs } from 'dayjs';

import { SelectedProjectJobs } from 'types/JobTypes';
import { ProjectScopeResponse } from 'types/ProjectTypes';
import { UserType } from 'types/WorkLogTypes';
import { PROJECT_STATUS } from 'utils/constants';
interface ProjectManagementFiltersProps {
  assignee: string;
  managers: string;
  taskGroup: string;
  searchQuery: string;
  projectStatus: string;
  endDate: Dayjs | null;
  startDate: Dayjs | null;
  assigneeList: UserType[] | [];
  jobAssigneeList: UserType[] | [];
  selectedProjectScope: string | null;
  projectJobs: SelectedProjectJobs[] | [];
  projectScopeList: ProjectScopeResponse[] | [];
}

const initialState: ProjectManagementFiltersProps = {
  projectJobs: [],
  taskGroup: '',
  endDate: null,
  searchQuery: '',
  assignee: 'All',
  managers: 'All',
  startDate: null,
  assigneeList: [],
  jobAssigneeList: [],
  projectScopeList: [],
  selectedProjectScope: null,
  projectStatus: PROJECT_STATUS.all.value,
};

const projectFilterSlice = createSlice({
  name: 'projectFilters',
  initialState,
  reducers: {
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    setAssignee: (state, action: PayloadAction<string>) => {
      state.assignee = action.payload;
    },
    setManagers: (state, action: PayloadAction<string>) => {
      state.managers = action.payload;
    },
    setProjectStatus: (state, action: PayloadAction<string>) => {
      state.projectStatus = action.payload;
    },
    setProjectJobs: (state, action: PayloadAction<SelectedProjectJobs[] | []>) => {
      state.projectJobs = action.payload;
    },
    setStartDate: (state, action: PayloadAction<Dayjs | null>) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action: PayloadAction<Dayjs | null>) => {
      state.endDate = action.payload;
    },
    setProjectScope: (state, action: PayloadAction<ProjectScopeResponse[]>) => {
      state.projectScopeList = action.payload;
    },
    setSelectedProjectScope: (state, action: PayloadAction<string | null>) => {
      state.selectedProjectScope = action.payload;
    },
    setAssigneeList: (state, action: PayloadAction<UserType[] | []>) => {
      state.assigneeList = action.payload;
    },
    setJobAssigneeList: (state, action: PayloadAction<UserType[] | []>) => {
      state.jobAssigneeList = action.payload;
    },
    resetFilters: (state) => ({ ...initialState, assigneeList: state.assigneeList }),
  },
});

export const { actions: projectFilterActions, reducer } = projectFilterSlice;

export default projectFilterSlice.reducer;
